<template>
  <soc-dialog
    :visible.sync="visible"
    width="900px"
    height="700px"
    @close="handleCancel"
    title="访客邀约详情"
    :is-footer="false"
  >
    <el-scrollbar class="history-info">
      <div class="history-info__basic">
        <h3 class="info-title">基本信息</h3>
        <div class="basic-info">
          <div class="basic-info__item">
            <div class="item-label">邀约来访时间</div>
            <div class="item-value">
              <!-- {{ getDateStr(info.visitDate, 'YYYY-MM-DD hh:mm:ss') }} -->
            </div>
          </div>
          <div class="basic-info__item noMargin">
            <div class="item-label">接待人</div>
            <div class="item-value">{{ info.visitorReceiverName }}</div>
          </div>
          <div class="basic-info__item noMargin">
            <div class="item-label">实际来访时间</div>
            <div class="item-value">
              <!-- {{
                info.startTime && info.endTime
                  ? getDateStr(info.startTime, 'YYYY-MM-DD hh:mm:ss') +
                    '~' +
                    getDateStr(info.endTime, 'YYYY-MM-DD hh:mm:ss')
                  : '暂无'
              }} -->
            </div>
          </div>
          <div class="basic-info__item noMargin" style="width: 834px">
            <div class="item-label">来访事由</div>
            <div class="item-value">
              {{ info.visitCause }}
            </div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">邀约时间</div>
            <div class="item-value">{{ info.visitDate }}</div>
          </div>
          <div class="basic-info__item noMargin">
            <div class="item-label">邀约人</div>
            <div class="item-value">{{ info.appointmentPersonName }}</div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">签入时间</div>
            <div class="item-value">
              {{ getDateStr(info.signTime, 'YYYY-MM-DD hh:mm:ss') }}
            </div>
          </div>
          <div class="basic-info__item noMargin">
            <div class="item-label">签离入人</div>
            <div class="item-value">{{ info.signUserName || '暂无' }}</div>
          </div>
          <div class="basic-info__item">
            <div class="item-label">签离时间</div>
            <div class="item-value">
              {{ getDateStr(info.leaveTime, 'YYYY-MM-DD hh:mm:ss') }}
            </div>
          </div>
          <div class="basic-info__item noMargin">
            <div class="item-label">签离人</div>
            <div class="item-value">{{ info.leaveUser || '暂无' }}</div>
          </div>
        </div>
      </div>
      <div class="history-info__abnormal">
        <h3 class="info-title">访客信息</h3>
        <soc-table
          :is-pagination="false"
          :columns="tableColumns"
          :data="info.passPersonnelList"
        >
          <template #imageUrl="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              content="照片"
              placement="top"
            >
              <el-image
                style="width: 50px; height: 50px"
                :src="row.imageUrl"
                :preview-src-list="[row.imageUrl]"
              >
              </el-image>
            </el-tooltip>
            <!-- <img
                v-lazy="imgPath(row.imageUrl)"
                alt=""
                style="width: 50px; height: 50px"
              /> -->
          </template>
          <template #personSex="{ row }">
            {{ sexKeys[row.personSex] }}
          </template>
        </soc-table>
      </div>
    </el-scrollbar>
  </soc-dialog>
</template>

<script>
// import { getDateStr } from '@/common/utils'

export default {
  name: 'invitationInfoComponent',
  inject: ['openImage'],
  data() {
    return {
      visible: false,
      info: {},
      sexKeys: {
        0: '男',
        1: '女'
      },
      tableColumns: [
        {
          label: '序号',
          prop: 'index',
          width: 80
        },
        {
          label: '照片',
          prop: 'imageUrl'
        },
        {
          label: '访客姓名',
          prop: 'personName'
        },
        {
          label: '性别',
          prop: 'personSex'
        },
        {
          label: '手机号码',
          prop: 'personPhone'
        },
        {
          label: '身份证号',
          prop: 'idCardNo'
        },
        {
          label: '车辆号牌',
          prop: 'plateNumber'
        }
      ],
      tableData: [
        {
          picture: '',
          visitorName: '孙文强',
          gender: '男',
          phone: '138****3900',
          number: '320***********5516',
          vehiclePlate: '苏A4P888'
        }
      ]
    }
  },
  mounted() {
    this.visible = true
  },
  methods: {
    // getDateStr(date, format) {
    //   if (!date) return '暂无'
    //   return getDateStr(date, format)
    // },
    handleCancel() {
      this.$emit('handleCancel')
    },
    handleOpenPic(url) {
      this.openImage(url)
    }
  }
}
</script>

<style lang='scss' scoped>
.history-info {
  display: flex;
  flex-direction: column;

  .info-title {
    // color: #fff;
    border-left-width: 3px;
    border-left-style: solid;
    padding-left: 10px;
    border-left-color: #407aee;
  }

  &__basic {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 20px;

    .basic-info {
      display: flex;
      flex-wrap: wrap;

      &__item {
        // background-color: #2b3452;
        padding: 6px 10px;
        line-height: 20px;
        width: 407px;
        margin-right: 20px;
        margin-top: 16px;
        display: flex;
        align-items: center;

        .item-label {
          margin-right: 10px;
        }

        .item-value {
          flex: 1;
          width: 0;
          word-break: break-all;
          // color: white;
        }

        &.noMargin {
          margin-right: 0;
        }
      }

      &__picItem {
        width: 114px;
        height: 114px;
        margin-top: 15px;
        margin-right: 15px;
        border: 1px dashed #3b6ed5;

        .item-img {
          width: 100%;
          height: 100%;
        }
      }

      &__videoItem {
        width: 300px;
        height: 170px;
        margin-top: 15px;
        margin-right: 15px;

        .item-img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .basic-status {
      position: absolute;
      width: 100px;
      height: 100px;
      border: 1px solid #a4a7b1;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffff00;
      right: 15px;
      top: 75px;
      font-size: 20px;
      font-weight: bold;
    }
  }

  &__abnormal {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    height: 250px;

    .info-title {
      margin-bottom: 16px;
    }
  }

  &__record {
    display: flex;
    flex-direction: column;
    height: 300px;

    .info-title {
      margin-bottom: 16px;
    }
  }
}
</style>
